import { render, staticRenderFns } from "./TypeClickable.vue?vue&type=template&id=732524d5&scoped=true"
import script from "./TypeClickable.vue?vue&type=script&lang=js"
export * from "./TypeClickable.vue?vue&type=script&lang=js"
import style0 from "./TypeClickable.vue?vue&type=style&index=0&id=732524d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732524d5",
  null
  
)

export default component.exports